module.exports = __webpack_public_path__ + "static/media/Crest-and-Logo.42ded79f.webp";